var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from 'react';
import { FormGroupLabel } from '../FormGroupLabel';
import Icon from '../../icon/Icon';
import { mdiMagnify, mdiClose } from '@mdi/js';
import { COLORS } from '../../color';
import ButtonIcon from '../../icon/ButtonIcon';
var InputVertical = /** @class */ (function (_super) {
    __extends(InputVertical, _super);
    function InputVertical() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputVertical.prototype.render = function () {
        var _a = this.props, name = _a.name, type = _a.type, label = _a.label, isRequired = _a.isRequired, value = _a.value, valid = _a.valid, invalid = _a.invalid, disabled = _a.disabled, feedback = _a.feedback, onChange = _a.onChange, className = _a.className, placeholder = _a.placeholder, min = _a.min, max = _a.max, step = _a.step, autoFocus = _a.autoFocus, autoComplete = _a.autoComplete, inputClassName = _a.inputClassName, onFocus = _a.onFocus, onBlur = _a.onBlur, isRounded = _a.isRounded, helpText = _a.helpText, onKeyDown = _a.onKeyDown, id = _a.id, size = _a.size, isSearchInput = _a.isSearchInput, onClearValue = _a.onClearValue;
        return (React.createElement(FormGroupLabel, { feedback: feedback, isRounded: isRounded, label: label, helpText: helpText, valid: valid, invalid: invalid, isRequired: isRequired, className: className },
            React.createElement("div", { className: 'input-for-search w-100' },
                React.createElement("input", { id: id, name: name, type: type, value: value !== null && value !== void 0 ? value : '', required: isRequired ? isRequired : false, disabled: disabled, placeholder: placeholder, min: min, max: max, step: step, autoFocus: autoFocus, autoComplete: autoComplete ? autoComplete : 'off', onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, className: 'gr-input ' +
                        (size ? size : 'lg') +
                        (isRounded ? ' round' : '') +
                        (valid ? ' valid ' : '') +
                        (invalid ? ' invalid ' : '') +
                        (isSearchInput && size === 'sm' ? ' pr-x8 ' : '') +
                        (isSearchInput && size === 'lg' ? ' pr-x10 ' : '') +
                        (inputClassName ? inputClassName : ''), onChange: function (evt) {
                        onChange(evt.target.value);
                    } }),
                isSearchInput && (React.createElement(React.Fragment, null, value === null || value === '' ? (React.createElement(Icon, { path: mdiMagnify, color: COLORS.gray600, size: size === 'sm' ? 0.7 : 1, className: 'search-icon-position' })) : (React.createElement(ButtonIcon, { iconPath: mdiClose, color: COLORS.gray600, size: size === 'sm' ? 'sm' : 'md', title: 'Очистить', className: 'search-icon-position', onClick: onClearValue })))))));
    };
    return InputVertical;
}(PureComponent));
export default InputVertical;
//# sourceMappingURL=InputVertical.js.map